angular.module('MW.Influencers.AnalyticsService', [
        'MW.Framework.MomentService',
        'MW.Framework.AnalyticsConstants',
        'angulartics',
        'angulartics.segment.io',
        'MW.Configuration'
    ])
    .factory('AnalyticsService', [
        '$analytics',
        '$location',
        'ANALYTICS_CONSTANTS',
        'moment',
        function ($analytics, $location, ANALYTICS_CONSTANTS, moment) {
            'use strict';

            var analyticsServiceObj = {},
                sentiment = {
                    'P': ANALYTICS_CONSTANTS.POSITIVE,
                    'V': ANALYTICS_CONSTANTS.NEGATIVE,
                    'N': ANALYTICS_CONSTANTS.NEUTRAL,
                    'U': ANALYTICS_CONSTANTS.NOT_RATED
                },
                mailSources = [
                    ANALYTICS_CONSTANTS.SOURCE_MAIL,
                    ANALYTICS_CONSTANTS.SOURCE_MAIL_DIGEST,
                    ANALYTICS_CONSTANTS.SOURCE_MAIL_DASHBOARD,
                    ANALYTICS_CONSTANTS.SOURCE_MAIL_NOTIFICATION,
                    ANALYTICS_CONSTANTS.SOURCE_MAIL_SHARE,
                    ANALYTICS_CONSTANTS.SOURCE_MAIL_NEWSLETTER,
                    ANALYTICS_CONSTANTS.SOURCE_OUTPUT_NEWSFEED
                ],
                source,
                IS_FIRST_DOCUMENT_OPERATION_TRACKING = true;

            /**
             * (Public)
             * Makes a call to analytics services to update the tracking
             * tracking status for the email dashboard/invite collaborators.
             * @param label
             * @param category
             */
            analyticsServiceObj.registerAnalytic = function registerAnalytic(label, category) {
                var properties = {};

                if (category) {
                    properties[ANALYTICS_CONSTANTS.CATEGORY] = category;
                }
                properties[ANALYTICS_CONSTANTS.LABEL] = label;

                $analytics.eventTrack('Share Dashboard Button Clicked', properties);
            };

            /**
             * (Public)
             *
             * Makes a call to analytics services to update the tracking
             * tracking status for the date range selector.
             *
             * @param parent, range
             * @returns {date_range properties}
             */
            analyticsServiceObj.dateRangeTrack = function dateRangeTrack(parent, range) {
                var properties = {};
                properties[ANALYTICS_CONSTANTS.LABEL] = ANALYTICS_CONSTANTS.UPDATE_DATE_RANGE;
                if (parent && parent.dashboard && parent.dashboardId) {
                    properties[ANALYTICS_CONSTANTS.CATEGORY] = ANALYTICS_CONSTANTS.DASHBOARDS;
                    properties[ANALYTICS_CONSTANTS.DASHBOARD_ID] = parent.dashboardId;
                }

                if (parent && parent.$parent && parent.$parent.inboxItemToDisplay) {
                    properties[ANALYTICS_CONSTANTS.CATEGORY] = ANALYTICS_CONSTANTS.INBOX;
                    properties[ANALYTICS_CONSTANTS.NAME] = parent.$parent.inboxItemToDisplay;
                }

                if (parent && parent.$parent && parent.$parent.savedSearchData && parent.$parent.savedSearchData.name) {
                    properties[ANALYTICS_CONSTANTS.CATEGORY] = ANALYTICS_CONSTANTS.SELECTED_SEARCHES;
                    properties[ANALYTICS_CONSTANTS.NAME] = parent.$parent.savedSearchData.name;
                }

                if (parent && parent.$parent && parent.$parent.tagName) {
                    properties[ANALYTICS_CONSTANTS.CATEGORY] = ANALYTICS_CONSTANTS.SELECTED_TAG;
                    properties[ANALYTICS_CONSTANTS.NAME] = parent.$parent.tagName;
                }

                if (range && range.absoluteStartDate && range.absoluteEndDate) {
                    properties[ANALYTICS_CONSTANTS.START_DATE] = range.absoluteStartDate._d;
                    properties[ANALYTICS_CONSTANTS.END_DATE] = range.absoluteEndDate._d;
                }

                $analytics.eventTrack(ANALYTICS_CONSTANTS.PERSONAL_SETTING_OPERATION, properties);

            };

            /**
             * (Public)
             *
             * Makes a call to analytics services to update the tracking
             * tracking status for the comparison date range selector.
             *
             * @param parent, range
             * @returns {date_range properties}
             */
            analyticsServiceObj.previousDateRangeTrack = function previousDateRangeTrack(parent, previousRange) {
                var properties = {};
                properties[ANALYTICS_CONSTANTS.LABEL] = ANALYTICS_CONSTANTS.UPDATE_DATE_RANGE;
                if (parent && parent.dashboard && parent.dashboardId) {
                    properties[ANALYTICS_CONSTANTS.CATEGORY] = ANALYTICS_CONSTANTS.DASHBOARDS;
                    properties[ANALYTICS_CONSTANTS.DASHBOARD_ID] = parent.dashboardId;
                }

                if (parent && parent.$parent && parent.$parent.inboxItemToDisplay) {
                    properties[ANALYTICS_CONSTANTS.CATEGORY] = ANALYTICS_CONSTANTS.INBOX;
                    properties[ANALYTICS_CONSTANTS.NAME] = parent.$parent.inboxItemToDisplay;
                }

                if (parent && parent.$parent && parent.$parent.savedSearchData && parent.$parent.savedSearchData.name) {
                    properties[ANALYTICS_CONSTANTS.CATEGORY] = ANALYTICS_CONSTANTS.SELECTED_SEARCHES;
                    properties[ANALYTICS_CONSTANTS.NAME] = parent.$parent.savedSearchData.name;
                }

                if (parent && parent.$parent && parent.$parent.tagName) {
                    properties[ANALYTICS_CONSTANTS.CATEGORY] = ANALYTICS_CONSTANTS.SELECTED_TAG;
                    properties[ANALYTICS_CONSTANTS.NAME] = parent.$parent.tagName;
                }

                if (previousRange && previousRange.relativeDate) {
                    properties[ANALYTICS_CONSTANTS.DATE_RANGE_SECONDARY_INPUT] = previousRange.relativeDate;
                }

                $analytics.eventTrack(ANALYTICS_CONSTANTS.PERSONAL_SETTING_OPERATION, properties);

            };

            /**
             * (Public)
             *
             * Makes a call to analytics services to update the tracking
             * tracking status for the Entitlement Limit
             *
             * @param action
             */
            analyticsServiceObj.showEntitlementLimit = function showEntitlementLimit(action) {
                var properties = {};

                properties[ANALYTICS_CONSTANTS.CATEGORY] = ANALYTICS_CONSTANTS.ENTITLEMENT;
                properties[ANALYTICS_CONSTANTS.LABEL] = action;

                $analytics.eventTrack(ANALYTICS_CONSTANTS.ENTITLEMENT_LIMIT, properties);
            };

            /**
             * (Public)
             *
             * Makes a call to analytics services to update the tracking
             * tracking status for the document.
             *
             * @param event
             * @param payload
             * @param documentId
             * @param searchId
             * @param action
             */
            analyticsServiceObj.trackDocumentList = function trackDocumentList(event, payload, documentId, searchId, action) {
                var properties = {},
                    documentUrl = payload.url,
                    savedSearchName = payload.name,
                    source = payload.s,
                    type = payload.type;
                if (!source) {
                    source = ANALYTICS_CONSTANTS.SOURCE_WEBAPP;
                }
                properties[ANALYTICS_CONSTANTS.CATEGORY] = ANALYTICS_CONSTANTS.MAIL_REPORT_ACTION;
                properties[ANALYTICS_CONSTANTS.LABEL] = documentUrl;
                properties[ANALYTICS_CONSTANTS.NAME] = savedSearchName;
                properties[ANALYTICS_CONSTANTS.SOURCE] = source;
                properties[ANALYTICS_CONSTANTS.TYPE] = type;
                properties[ANALYTICS_CONSTANTS.DOCUMENT_ID] = documentId;
                properties[ANALYTICS_CONSTANTS.ID] = searchId;

                if (action === 'open') {
                    properties[ANALYTICS_CONSTANTS.IS_PREMIUM] = 'true';
                }

                $analytics.eventTrack(event, properties);
            };

            /**
             * (Public)
             *
             * Makes a call to analytics services to update the tracking
             * tracking status for the find option.
             */
            analyticsServiceObj.findOption = function findOption() {
                var properties = {},
                    path = $location.path(),
                    type = '',
                    typeArray = {
                        0: ANALYTICS_CONSTANTS.INBOX,
                        1: ANALYTICS_CONSTANTS.DASHBOARD,
                        2: ANALYTICS_CONSTANTS.SEARCH,
                        3: ANALYTICS_CONSTANTS.TAG,
                        4: ANALYTICS_CONSTANTS.OUTPUT,
                        5: ANALYTICS_CONSTANTS.REPORT,
                        6: ANALYTICS_CONSTANTS.RSS
                    };

                angular.forEach(typeArray, function (val) {
                    val = val.toLowerCase();
                    if (path.indexOf(val) > -1) {
                        type = val;
                        return type;
                    }
                });

                properties[ANALYTICS_CONSTANTS.CATEGORY] = ANALYTICS_CONSTANTS.CONTENT_STREAM;
                properties[ANALYTICS_CONSTANTS.TYPE] = type;
                properties[ANALYTICS_CONSTANTS.SOURCE] = ANALYTICS_CONSTANTS.SOURCE_WEBAPP;

                $analytics.eventTrack(ANALYTICS_CONSTANTS.FIND_DOCUMENT, properties);
            };

            /**
             * (Public)
             *
             * Makes a call to analytics tracking when a user clicks an item in the navigation
             *
             * @param event
             * @param eventData
             */
            analyticsServiceObj.trackNavigation = function (event, eventData) {
                var properties = {};

                properties[ANALYTICS_CONSTANTS.LABEL] = event;
                properties[ANALYTICS_CONSTANTS.SOURCE] = (mailSources.indexOf(source) !== -1 ) ? source : ANALYTICS_CONSTANTS.SOURCE_WEBAPP;
                properties[ANALYTICS_CONSTANTS.SOURCE_PAGE] = eventData.sourceUrl;
                properties[ANALYTICS_CONSTANTS.NAVIGATION_TYPE] = eventData.type;
                properties[ANALYTICS_CONSTANTS.DESTINATION_PAGE] = eventData.url;
                properties[ANALYTICS_CONSTANTS.PIN_STATUS] = eventData.pinStatus;
                properties[ANALYTICS_CONSTANTS.DESTINATION_PAGE_TYPE] = eventData.label;
                properties[ANALYTICS_CONSTANTS.LANGUAGE] = eventData.language;

                $analytics.eventTrack(ANALYTICS_CONSTANTS.CLICK_NAVIGATION, properties);

            };

            /**
             * (Public)
             *
             * Makes a call to analytics tracking when a user views content stream results
             *
             * @param data
             */
            analyticsServiceObj.trackViewContentStream = function trackViewContentStream(data) {
                if ((window.location && window.location.href) && (window.location.href.indexOf('pdf_layout') > 0  || window.location.href.indexOf('email_layout') > 0)) {
                    return null;
                }

                var properties = {},
                    inputId = null,
                    inputName = null,
                    openingText = null,
                    totalDocuments = null,
                    findFilter = null,
                    eventData = data.eventData,
                    parentType = data.parentType,
                    tagName = null,
                    sortBy = eventData.query.sortField;

                if (parentType === 'Search') {
                    inputId = eventData.savedSearchData.savedSearchId;
                    inputName = eventData.savedSearchData.name;
                    openingText = eventData.rowDisplaySettings.openingText;
                    totalDocuments = eventData.DocumentStreamData.totalDocuments;
                } else if (parentType === 'inbox') {
                    inputName = data.sourceDetail.name;
                    inputId = data.sourceDetail.id;
                    openingText = eventData.rowDisplaySettings.openingText;
                    totalDocuments = eventData.documentStreamData.totalDocuments;
                } else if (parentType === 'Tag') {
                    totalDocuments = eventData.DocumentStreamData.totalDocuments;
                    openingText = eventData.rowDisplaySettings.openingText;
                    tagName = eventData.tagName;
                }
                if (sortBy === 'country') {
                    sortBy = 'geo';
                }

                properties[ANALYTICS_CONSTANTS.LABEL] = ANALYTICS_CONSTANTS.VIEW;
                properties[ANALYTICS_CONSTANTS.SOURCE] = (mailSources.indexOf(source) !== -1 ) ? source : ANALYTICS_CONSTANTS.SOURCE_WEBAPP;
                properties[ANALYTICS_CONSTANTS.INPUT_ID] = inputId;
                properties[ANALYTICS_CONSTANTS.INPUT_NAME] = inputName;
                properties[ANALYTICS_CONSTANTS.PARENT_TYPE] = parentType;
                properties[ANALYTICS_CONSTANTS.TAG_NAME] = tagName;
                properties[ANALYTICS_CONSTANTS.FIND_FILTER] = findFilter;
                properties[ANALYTICS_CONSTANTS.SORT_BY] = sortBy;
                properties[ANALYTICS_CONSTANTS.SORT_DIRECTION] = eventData.query.sortOrder;
                properties[ANALYTICS_CONSTANTS.OPENING_TEXT_FLAG] = openingText;
                properties[ANALYTICS_CONSTANTS.HIT_SENTENCE_FLAG] = eventData.rowDisplaySettings.hitSentence;
                properties[ANALYTICS_CONSTANTS.TAG_FLAG] = eventData.rowDisplaySettings.displayTags;
                properties[ANALYTICS_CONSTANTS.IMAGE_FLAG] = eventData.rowDisplaySettings.images;
                properties[ANALYTICS_CONSTANTS.GROUPING] = eventData.query.groupOption;
                properties[ANALYTICS_CONSTANTS.START_DATE] = moment(eventData.query.dateStart).format('YYYY-MM-DD');
                properties[ANALYTICS_CONSTANTS.END_DATE] = moment(eventData.query.dateEnd).format('YYYY-MM-DD');
                properties[ANALYTICS_CONSTANTS.STREAM_TYPE] = data.streamType;
                properties[ANALYTICS_CONSTANTS.NUMBER_OF_RESULTS_SHOWN] = totalDocuments;

                $analytics.eventTrack(ANALYTICS_CONSTANTS.CONTENT_STREAM, properties);

            };

            analyticsServiceObj.applyOverlaySentiment = function applyOverlaySentiment(eventData) {
                var documents = eventData.documentDetails,
                    properties = {};

                angular.forEach(documents, function (document) {
                    properties = {};
                    properties[ANALYTICS_CONSTANTS.SAVED_SEARCH_ID] = eventData.savedSearchId ? eventData.savedSearchId : null;
                    properties[ANALYTICS_CONSTANTS.SAVED_SEARCH_NAME] = eventData.savedSearchName ? eventData.savedSearchName : null;
                    properties[ANALYTICS_CONSTANTS.LABEL] = eventData.event.toLowerCase();
                    properties[ANALYTICS_CONSTANTS.SOURCE] = (mailSources.indexOf(source) !== -1 ) ? source : ANALYTICS_CONSTANTS.SOURCE_WEBAPP;
                    properties[ANALYTICS_CONSTANTS.DOCUMENT_URL] = document.url;
                    properties[ANALYTICS_CONSTANTS.DOCUMENT_ID] = document.documentId;
                    properties[ANALYTICS_CONSTANTS.IS_PREMIUM] = document.isHosted;
                    properties[ANALYTICS_CONSTANTS.TAG_NAME] = (document.tags && document.tags.length > 0) ? document.tags.join('|') : null;
                    properties[ANALYTICS_CONSTANTS.PARENT_TYPE] = (mailSources.indexOf(source) !== -1) ? ANALYTICS_CONSTANTS.EMAIL : eventData.parentType.toLowerCase();
                    properties[ANALYTICS_CONSTANTS.SHARE_MECHANISM] = null;
                    properties[ANALYTICS_CONSTANTS.TRANSLATE_API] = null;
                    properties[ANALYTICS_CONSTANTS.LANGUAGE_PAIR] = null;
                    properties[ANALYTICS_CONSTANTS.RECIPIENTS] = null;
                    properties[ANALYTICS_CONSTANTS.SUBJECT_LINE] = null;
                    properties[ANALYTICS_CONSTANTS.INCLUDE_OPENING_FLAG] = null;
                    properties[ANALYTICS_CONSTANTS.INCLUDE_HIT_FLAG] = null;
                    properties[ANALYTICS_CONSTANTS.ADDITIONAL_COMMENT] = null;
                    properties[ANALYTICS_CONSTANTS.SENTIMENT] = sentiment[eventData.sentiment];
                    properties[ANALYTICS_CONSTANTS.EXPORT_FORMAT] = null;

                    $analytics.eventTrack(ANALYTICS_CONSTANTS.DOCUMENT_OPERATION, properties);
                });
            };

            /**
             * (Public)
             *
             * Makes a call to analytics tracking when a user clicks on get more results button.
             *
             * @param documentsConfig
             */
            analyticsServiceObj.getMoreResultsEventTrack = function getMoreResultsEventTrack(documentsConfig) {
                var searchCriteria = '',
                    properties = {};

                if (documentsConfig && documentsConfig.searches && documentsConfig.searches.length > 0) {
                    searchCriteria = documentsConfig.searches[0].searchQuery;
                    if (documentsConfig.searches[0].name && documentsConfig.searches[0].savedSearchId) {
                        properties[ANALYTICS_CONSTANTS.LABEL] = documentsConfig.searches[0].name;
                        properties[ANALYTICS_CONSTANTS.SAVED_SEARCH_ID] = documentsConfig.searches[0].savedSearchId;
                    }
                } else if (documentsConfig && documentsConfig.savedSearchData && typeof documentsConfig.savedSearchData !== 'undefined'
                ) {
                    searchCriteria = documentsConfig.savedSearchData.searchQuery;
                    if (documentsConfig.savedSearchData.name && documentsConfig.savedSearchData.savedSearchId) {
                        properties[ANALYTICS_CONSTANTS.LABEL] = documentsConfig.savedSearchData.name;
                        properties[ANALYTICS_CONSTANTS.SAVED_SEARCH_ID] = documentsConfig.savedSearchData.savedSearchId;
                    }
                }

                if (searchCriteria) {
                    properties[ANALYTICS_CONSTANTS.CATEGORY] = ANALYTICS_CONSTANTS.CONTENT_STREAM;

                    properties[ANALYTICS_CONSTANTS.SEARCH_TYPE] = searchCriteria.searchQueryType;

                    if (searchCriteria.allKeywords && searchCriteria.allKeywords.length > 0) {
                        properties[ANALYTICS_CONSTANTS.SEARCH_QUERY_ALL] = searchCriteria.allKeywords;
                    }

                    if (searchCriteria.anyKeywords && searchCriteria.anyKeywords.length > 0) {
                        properties[ANALYTICS_CONSTANTS.SEARCH_QUERY_ANY] = searchCriteria.anyKeywords;
                    }

                    if (searchCriteria.notKeywords && searchCriteria.notKeywords.length > 0) {
                        properties[ANALYTICS_CONSTANTS.SEARCH_QUERY_NONE] = searchCriteria.notKeywords;
                    }

                    if (searchCriteria.booleanQuery && searchCriteria.booleanQuery.length > 0) {
                        properties[ANALYTICS_CONSTANTS.SEARCH_QUERY_BOOLEAN] = searchCriteria.booleanQuery;
                    }

                    properties[ANALYTICS_CONSTANTS.SOURCE_SELECTION_ID] = searchCriteria.sourceSelectionId;
                    properties[ANALYTICS_CONSTANTS.SOURCE] = ANALYTICS_CONSTANTS.SOURCE_WEBAPP;

                    $analytics.eventTrack(ANALYTICS_CONSTANTS.VIEW_MORE_RESULTS, properties);
                }

            };

            /**
             * (Public)
             *
             * Makes a call to analytics tracking when a user share,translate & open a Document.
             *
             * @param data
             */
            analyticsServiceObj.documentOperation = function documentOperation(data) {
                var properties;

                // GYDA-18623 - Action taken from mailSources should only be tracked under mailSources and
                // other actions taken within the web-app should be tracked under source web-app.
                if (IS_FIRST_DOCUMENT_OPERATION_TRACKING) {
                    if ($location.url().indexOf('/open/documents/') >= 0) {
                        source = $location.search().s ? $location.search().s : $location.search().source;
                    }
                    IS_FIRST_DOCUMENT_OPERATION_TRACKING = false;
                }

                properties = this.buildPropertiesForDocumentOperation(data);

                $analytics.eventTrack(ANALYTICS_CONSTANTS.DOCUMENT_OPERATION, properties);
            };


            analyticsServiceObj.buildPropertiesForDocumentOperation = function buildPropertiesForDocumentOperation(data) {
                var document = data.document,
                    sourceDetail,
                    properties = {},
                    tags = [],
                    label = data.label;

                if (data.sourceDetail) {
                    if (data.sourceDetail.name && data.sourceDetail.id) {
                        sourceDetail = data.sourceDetail;
                    } else {
                        sourceDetail = null;
                    }
                }
                if (document.tags && document.tags.length > 0) {
                    for (var key in document.tags) {
                        if (document.tags[key].name !== undefined) {
                            tags.push(document.tags[key].name);
                        } else {
                            tags.push(document.tags[key]);
                        }
                    }
                    tags = tags.join('|');
                } else {
                    tags = null;
                }

                properties[ANALYTICS_CONSTANTS.LABEL] = label;

                properties[ANALYTICS_CONSTANTS.SOURCE] = (mailSources.indexOf(source) !== -1 ) ? source :
                    data.source ? data.source : ANALYTICS_CONSTANTS.SOURCE_WEBAPP;

                properties[ANALYTICS_CONSTANTS.DOCUMENT_URL] = document.url;
                properties[ANALYTICS_CONSTANTS.DOCUMENT_ID] = document.documentId;
                properties[ANALYTICS_CONSTANTS.SAVED_SEARCH_ID] = sourceDetail ? sourceDetail.id : null;
                properties[ANALYTICS_CONSTANTS.SAVED_SEARCH_NAME] = sourceDetail ? sourceDetail.name : null;
                properties[ANALYTICS_CONSTANTS.IS_PREMIUM] = document.isHosted;
                properties[ANALYTICS_CONSTANTS.TAG_NAME] = tags;
                properties[ANALYTICS_CONSTANTS.PARENT_TYPE] = (mailSources.indexOf(source) !== -1) ? ANALYTICS_CONSTANTS.EMAIL : data.parentType.toLowerCase();
                properties[ANALYTICS_CONSTANTS.SHARE_MECHANISM] = data.socialType ? data.socialType : null;
                properties[ANALYTICS_CONSTANTS.TRANSLATE_API] = data.translateApi ? data.translateApi : null;
                properties[ANALYTICS_CONSTANTS.LANGUAGE_PAIR] = data.languagePair ? data.languagePair : null;
                properties[ANALYTICS_CONSTANTS.RECIPIENTS] = null;
                properties[ANALYTICS_CONSTANTS.SUBJECT_LINE] = null;
                properties[ANALYTICS_CONSTANTS.INCLUDE_OPENING_FLAG] = null;
                properties[ANALYTICS_CONSTANTS.INCLUDE_HIT_FLAG] = null;
                properties[ANALYTICS_CONSTANTS.ADDITIONAL_COMMENT] = null;
                properties[ANALYTICS_CONSTANTS.SENTIMENT] = sentiment[document.sentiment];
                properties[ANALYTICS_CONSTANTS.EXPORT_FORMAT] = (label === ANALYTICS_CONSTANTS.EXPORT) ? ANALYTICS_CONSTANTS.EXCEL : null;

                properties[ANALYTICS_CONSTANTS.COMPANY_ID] = data.cId ? data.cId : null;
                properties[ANALYTICS_CONSTANTS.USER_ID] = data.uId ? data.uId : null;

                // reset the source property to SOURCE_WEBAPP
                source = ANALYTICS_CONSTANTS.SOURCE_WEBAPP;

                return properties;
            };

            /**
             * (Public)
             *
             * Makes a general call to analytics tracking passing the parameter as the label
             *  for example: used when the contact us link is clicked, passes 'contact us'
             *
             * @param event
             */
            analyticsServiceObj.trackGeneralOperation = function (event) {
                var properties = {};

                properties[ANALYTICS_CONSTANTS.LABEL] = event;
                properties[ANALYTICS_CONSTANTS.CATEGORY] = ANALYTICS_CONSTANTS.GENERAL_CATEGORY;

                $analytics.eventTrack(ANALYTICS_CONSTANTS.GENERAL_OPERATION, properties);

            };

            /**
             * (Public)
             *
             * Makes a call to analytics tracking for every document hidden/unhidden
             *
             * @param eventData
             *
             * eventData = {
             *      event: 'hide' || 'unhide',
             *      source: 'webapp' || 'iOS' || 'android' || 'mail-digest' || 'mail-dashboard' || 'mail-newsletter' || 'output-newsfeed' || 'mail-notification' || 'mail-last5',
             *      documentDetails: {},
             *      searchSaveId: savedSearchId || null,
             *      savedSearchName: savedSearchName || null,
             *      parentType: 'inbox' | 'search' | 'dashboard' | 'tag'
             * }
             *
             */
            analyticsServiceObj.trackHideUnhideDocumentOperation = function trackHideUnhideDocumentOperation(eventData) {
                var documents = eventData.documentDetails,
                    properties = {};

                angular.forEach(documents, function(document) {
                    properties = {};
                    properties[ANALYTICS_CONSTANTS.LABEL] = eventData.event ? eventData.event.toLowerCase() : null;
                    properties[ANALYTICS_CONSTANTS.SOURCE] = eventData.source ? eventData.source.toLowerCase() : ANALYTICS_CONSTANTS.SOURCE_WEBAPP;
                    properties[ANALYTICS_CONSTANTS.DOCUMENT_URL] = document.url;
                    properties[ANALYTICS_CONSTANTS.DOCUMENT_ID] = document.documentId;
                    properties[ANALYTICS_CONSTANTS.SAVED_SEARCH_ID] = eventData.inputId ? eventData.inputId : null;
                    properties[ANALYTICS_CONSTANTS.SAVED_SEARCH_NAME] = eventData.inputName ? eventData.inputName : null;
                    properties[ANALYTICS_CONSTANTS.IS_PREMIUM] = document.isHosted;
                    properties[ANALYTICS_CONSTANTS.TAG_NAME] = (document.tags && document.tags.length > 0) ? document.tags.join('|') : null;
                    properties[ANALYTICS_CONSTANTS.PARENT_TYPE] = eventData.parentType ? eventData.parentType.toLowerCase() : null;
                    properties[ANALYTICS_CONSTANTS.SHARE_MECHANISM] = null;
                    properties[ANALYTICS_CONSTANTS.TRANSLATE_API] = null;
                    properties[ANALYTICS_CONSTANTS.LANGUAGE_PAIR] = null;
                    properties[ANALYTICS_CONSTANTS.RECIPIENTS] = null;
                    properties[ANALYTICS_CONSTANTS.SUBJECT_LINE] = null;
                    properties[ANALYTICS_CONSTANTS.INCLUDE_OPENING_FLAG] = null;
                    properties[ANALYTICS_CONSTANTS.INCLUDE_HIT_FLAG] = null;
                    properties[ANALYTICS_CONSTANTS.ADDITIONAL_COMMENT] = null;
                    properties[ANALYTICS_CONSTANTS.SENTIMENT] = sentiment[document.sentiment];
                    properties[ANALYTICS_CONSTANTS.EXPORT_FORMAT] = null;

                    $analytics.eventTrack(ANALYTICS_CONSTANTS.DOCUMENT_OPERATION, properties);
                });
            };

            /**
             * (Public)
             *
             * Makes a call to analytics to track a Content Stream Event triggered by a user
             *
             * @param eventData
             *
             * eventData = {
             *      source: 'webapp' || 'iOS' || 'android' || 'mail-digest' || 'mail-dashboard' || 'mail-newsletter' || 'output-newsfeed' || 'mail-notification' || 'mail-last5',
             *      streamType: 'content' || 'hidden' || 'influencer' || 'influencer_source',
             *      parentType: 'dashboard' || 'inbox' || 'search' || 'tag' || 'influencer_search',
             *      inputId: savedSearchId || null,
             *      inputName: savedSearchName || null,
             *      tagName: (only in tags view),
             *      findFilter: optional,
             *      query: {},
             *      rowDisplaySettings: {},
             *      numberOfResultsShown: int
             *      event: 'hide' | 'unhide',
             *      actionLimitReachedFlag: true || false,
             *      inlineSelectAllFlag: true || false,
             *      exportStatus: 'success' || 'failure' || null,
             *      numberOfArticlesSelected: int || null
             * }
             *
             */
            analyticsServiceObj.trackContentStreamEvent = function trackContentStreamEvent(eventData) {
                if ((window.location && window.location.href) && (window.location.href.indexOf('pdf_layout') > 0  || window.location.href.indexOf('email_layout') > 0)) {
                    return null;
                }

                var properties = {},
                    sortBy = (eventData.query && eventData.query.sortField) ? eventData.query.sortField.toLowerCase() : null;

                sortBy = (sortBy === 'country') ? 'geo' : sortBy;


                properties[ANALYTICS_CONSTANTS.SOURCE] = (mailSources.indexOf(source) !== -1 ) ? source : ANALYTICS_CONSTANTS.SOURCE_WEBAPP;
                properties[ANALYTICS_CONSTANTS.STREAM_TYPE] = eventData.streamType ? eventData.streamType.toLowerCase() : null;
                properties[ANALYTICS_CONSTANTS.PARENT_TYPE] = eventData.parentType ? eventData.parentType.toLowerCase() : null;
                properties[ANALYTICS_CONSTANTS.INPUT_ID] = eventData.inputId ? eventData.inputId : null;
                properties[ANALYTICS_CONSTANTS.INPUT_NAME] = eventData.inputName ? eventData.inputName.toLowerCase() : null;
                properties[ANALYTICS_CONSTANTS.TAG_NAME] = (eventData.parentType === ANALYTICS_CONSTANTS.TAG && eventData.tagName) ? eventData.tagName.toLowerCase() : null;
                properties[ANALYTICS_CONSTANTS.FIND_FILTER] = eventData.findFilter ? eventData.findFilter : null;
                properties[ANALYTICS_CONSTANTS.SORT_BY] = sortBy;
                properties[ANALYTICS_CONSTANTS.SORT_DIRECTION] = (eventData.query && eventData.query.sortOrder) ? eventData.query.sortOrder : null;
                properties[ANALYTICS_CONSTANTS.OPENING_TEXT_FLAG] = eventData.rowDisplaySettings.openingText;
                properties[ANALYTICS_CONSTANTS.HIT_SENTENCE_FLAG] = eventData.rowDisplaySettings.hitSentence;
                properties[ANALYTICS_CONSTANTS.TAG_FLAG] = eventData.rowDisplaySettings.displayTags;
                properties[ANALYTICS_CONSTANTS.IMAGE_FLAG] = eventData.rowDisplaySettings.images;
                properties[ANALYTICS_CONSTANTS.GROUPING] = (eventData.rowDisplaySettings && eventData.rowDisplaySettings.groupOption) ? eventData.rowDisplaySettings.groupOption : null;
                properties[ANALYTICS_CONSTANTS.START_DATE] = moment(eventData.query.dateStart).format('YYYY-MM-DD');
                properties[ANALYTICS_CONSTANTS.END_DATE] = moment(eventData.query.dateEnd).format('YYYY-MM-DD');
                properties[ANALYTICS_CONSTANTS.NUMBER_OF_RESULTS_SHOWN] = eventData.numberOfResultsShown ? eventData.numberOfResultsShown : null;
                properties[ANALYTICS_CONSTANTS.NUMBER_OF_ARTICLES_SELECTED] = eventData.numberOfArticlesSelected ? eventData.numberOfArticlesSelected : null;

                properties[ANALYTICS_CONSTANTS.LABEL] = eventData.event ? eventData.event.toLowerCase() : null;
                properties[ANALYTICS_CONSTANTS.ACTION_LIMIT_REACHED_FLAG] = eventData.actionLimitReachedFlag ? eventData.actionLimitReachedFlag : null;
                properties[ANALYTICS_CONSTANTS.INLINE_SELECT_ALL_FLAG] = eventData.inlineSelectAllFlag ? eventData.inlineSelectAllFlag : null;
                properties[ANALYTICS_CONSTANTS.SHARE_MECHANISM] = eventData.shareMechanism ? eventData.shareMechanism : null;
                properties[ANALYTICS_CONSTANTS.EXPORT_STATUS] = eventData.exportStatus ? eventData.exportStatus : null;

                $analytics.eventTrack(ANALYTICS_CONSTANTS.CONTENT_STREAM, properties);
            };

            /**
             * (Public)
             *
             * Makes a call to analytics to track ICM Profile Feedback Actions
             *
             * @param eventName
             * @param data
             * @param feedbackData (optional)
             *
             * data = {
             *      source: 'webapp' || 'iOS' || 'android' || 'mail-digest' || 'mail-dashboard' || 'mail-newsletter' || 'output-newsfeed' || 'mail-notification' || 'mail-last5',
             *      label: 'icm_contact_feedback_started' || 'icm_contact_feedback_completed',
             *      contact_id: Kermit uuid,
             *      user_id: user email (user FH id) user company name
             * }
             *
             * feedbackData = {
             *      type: incorrect_information | request_for_more_info | other
             *      description: optional string
             * }
             */
            analyticsServiceObj.trackFeedbackLoop = function trackFeedbackLoop(eventName, data, feedbackData) {
                var properties = {},
                    icmResource = 'contact',
                    feedbackTypeProperty,
                    feedbackDescProperty,
                    thisEvent;

                if (data.label.indexOf('icm_source') > -1) {
                    icmResource = 'source';
                }

                if (icmResource === 'contact') {
                    thisEvent = ANALYTICS_CONSTANTS.ICM_CONTACT_FEEDBACK_COMPLETED;
                    if (eventName === 'started') {
                        thisEvent = ANALYTICS_CONSTANTS.ICM_CONTACT_FEEDBACK_STARTED;
                    }
                    feedbackTypeProperty = ANALYTICS_CONSTANTS.ICM_CONTACT_FEEDBACK_TYPE;
                    feedbackDescProperty = ANALYTICS_CONSTANTS.ICM_CONTACT_FEEDBACK_DESC;
                }
                else {
                    thisEvent = ANALYTICS_CONSTANTS.ICM_SOURCE_FEEDBACK_COMPLETED;
                    if (eventName === 'started') {
                        thisEvent = ANALYTICS_CONSTANTS.ICM_SOURCE_FEEDBACK_STARTED;
                    }
                    feedbackTypeProperty = ANALYTICS_CONSTANTS.ICM_SOURCE_FEEDBACK_TYPE;
                    feedbackDescProperty = ANALYTICS_CONSTANTS.ICM_SOURCE_FEEDBACK_DESC;
                }

                properties[ANALYTICS_CONSTANTS.SOURCE] = data.source;
                properties[ANALYTICS_CONSTANTS.LABEL] = data.label;
                properties[ANALYTICS_CONSTANTS.ICM_USER_ID] = data.userId;
                if (icmResource === 'contact') {
                    properties[ANALYTICS_CONSTANTS.ICM_CONTACT_ID] = data.contactId;
                }
                else {
                    properties[ANALYTICS_CONSTANTS.ICM_SOURCE_ID] = data.sourceId;
                }

                if(feedbackData) {
                    switch(feedbackData.type) {
                        case 'incorrect':
                            properties[feedbackTypeProperty] = 'incorrect_information';
                            break;
                        case 'missing':
                            properties[feedbackTypeProperty] = 'request_for_more_info';
                            break;
                        case 'missingContact':
                            properties[feedbackTypeProperty] = 'missing_contact';
                            break;
                        default:
                            properties[feedbackTypeProperty] = feedbackData.type;
                    }

                    if (feedbackData.description) {
                        properties[feedbackDescProperty] = feedbackData.description;
                    }
                }

                $analytics.eventTrack(thisEvent, properties);
            };

            /**
             * (Public)
             *
             * Makes a call to analytics to track ICM Media list Operation Actions
             *
             * @param eventName
             * @param data
             *
             * data = {
             *      source: 'webapp' || 'iOS' || 'android' || 'mail-digest' || 'mail-dashboard' || 'mail-newsletter' || 'output-newsfeed' || 'mail-notification' || 'mail-last5',
             *      label: 'add_contact' || 'remove_contact' || 'export_contact' || 'outreach_email' || 'import_contact',
             *      media_list_id: media list identifier used by ICM
             *      nbr_of_contacts: Number of contacts included in the action
             *      parent_type: ICM_contact_lists, ICM_import_contacts (used for import_contact only)
             *      sub_type: a child type of the event
             *      user_id: user email (user FH id) user company name
             * }
             */
            analyticsServiceObj.trackMediaListOperation = function trackMediaListOperation(eventName, data) {
                var properties = {},
                    thisEvent;

                switch (eventName) {
                    case 'add_contact':
                        thisEvent = ANALYTICS_CONSTANTS.ICM_ADD_CONTACT;
                        break;
                    case 'remove_contact':
                        thisEvent = ANALYTICS_CONSTANTS.ICM_REMOVE_CONTACT;
                        break;
                    case 'export_contact':
                        thisEvent = ANALYTICS_CONSTANTS.ICM_EXPORT_CONTACT;
                        break;
                    case 'outreach_email':
                        thisEvent = ANALYTICS_CONSTANTS.ICM_OUTREACH_EMAIL;
                        break;
                    case 'import_contact':
                        thisEvent = ANALYTICS_CONSTANTS.ICM_IMPORT_CONTACT;
                        break;
                    default:
                        thisEvent = null;
                        break;
                }

                if (thisEvent) {
                    properties[ANALYTICS_CONSTANTS.SOURCE] = data.source;
                    properties[ANALYTICS_CONSTANTS.LABEL] = data.label;
                    properties[ANALYTICS_CONSTANTS.MEDIA_LIST_ID] = data.mediaListId;
                    properties[ANALYTICS_CONSTANTS.NBR_OF_CONTACTS] = data.contactCount;
                    properties[ANALYTICS_CONSTANTS.PARENT_TYPE] = data.parentType;
                    properties[ANALYTICS_CONSTANTS.SUB_TYPE] = data.subType;
                    properties[ANALYTICS_CONSTANTS.ICM_USER_ID] = data.userId;

                    $analytics.eventTrack(thisEvent, properties);
                }
            };

            /**
             * (Public)
             *
             * Makes a call to analytics to track ICM Search Operations
             *
             * @param data
             *
             * data = {
             *      source: 'webapp' || 'iOS' || 'android' || 'mail-digest' || 'mail-dashboard' || 'mail-newsletter' || 'output-newsfeed' || 'mail-notification' || 'mail-last5',
             *      label: 'icm_search',
             *      icm_search_type: 'contact' || 'source' || 'relevantContact' || 'relevantSource'
             *      icm_search_terms: string list of search terms delimited by pipes
             *      icm_search_filter: string list of filters used delimited by pipes
             *      results_nbr: integer of number of contacts returned from the search
             *      from_date: string date for relevant search
             *      to_date: string date for relevant search
             *      user_id: string 'email (userId) companyName'
             * }
             */
            analyticsServiceObj.trackIcmSearchOperation = function trackIcmSearchOperation(data) {
                var properties = {},
                    thisEvent = ANALYTICS_CONSTANTS.ICM_SEARCH;

                properties[ANALYTICS_CONSTANTS.SOURCE] = data.source;
                properties[ANALYTICS_CONSTANTS.LABEL] = data.label;
                properties[ANALYTICS_CONSTANTS.ICM_SEARCH_TYPE] = data.icm_search_type;
                properties[ANALYTICS_CONSTANTS.ICM_SEARCH_TERMS] = data.icm_search_terms;
                properties[ANALYTICS_CONSTANTS.ICM_SEARCH_FILTER] = data.icm_search_filter;
                properties[ANALYTICS_CONSTANTS.ICM_SEARCH_NUMBER_OF_RESULTS] = data.results_nbr;
                properties[ANALYTICS_CONSTANTS.ICM_SEARCH_START_DATE] = data.from_date;
                properties[ANALYTICS_CONSTANTS.ICM_SEARCH_END_DATE] = data.to_date;
                properties[ANALYTICS_CONSTANTS.ICM_USER_ID] = data.user_id;

                $analytics.eventTrack(thisEvent, properties);
            };

            return analyticsServiceObj;
        }]);
